<template>
    <div>
        <div class="flex h-screen-header overflow-y-auto">
            <ul class="menu bg-base-100 w-16 md:w-56 my-2 rounded-box">
                <li>
                    <a :class="{ 'active': activeIndex === 1 }" @click="handleActive(1)">
                        <svg-icon name="sys-home" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">基本设置</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 2 }" @click="handleActive(2)">
                        <svg-icon name="sys-backend" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">后台刮削</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 3 }" @click="handleActive(3)">
                        <svg-icon name="sys-backend-task" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">后台任务</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 4 }" @click="handleActive(4)">
                        <svg-icon name="sys-xiaoai" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">小爱音响</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 5 }" @click="handleActive(5)">
                        <svg-icon name="sys-webdav" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">网盘音乐</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 7 }" @click="handleActive(7)">
                        <svg-icon name="sys-openapi" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">开放 API</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 8 }" @click="handleActive(8)">
                        <svg-icon name="user" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">角色权限</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 6 }" @click="handleActive(6)">
                        <svg-icon name="sys-info" class="w-5 h-5 fill-current" />
                        <div class="!hidden md:!block">系统信息</div>
                    </a>
                </li>
            </ul>
            <div class="flex-1 mx-2 my-2 rounded-2xl bg-base-100 p-8 overflow-y-auto">
                <component :is="currentComponent" :form-data="formData" @update-sys="HandleUpdateSys" @redirect-edit="redirctEditDetail" />
            </div>
        </div>
    </div>
</template>
<script>
import BasicSettings from './components/BasicSettings.vue'
import BackgroundScraping from './components/BackgroundScraping.vue'
import BackgroundTasks from './components/BackgroundTasks.vue'
import XiaoaiSpeaker from './components/XiaoaiSpeaker.vue'
import WebdavMusic from './components/WebdavMusic.vue'
import SystemInfo from './components/SystemInfo.vue'
import OpenApi from './components/OpenApi.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import RolePermission from './components/RolePermission.vue'
export default {
    components: {
        BasicSettings,
        BackgroundScraping,
        BackgroundTasks,
        XiaoaiSpeaker,
        WebdavMusic,
        SystemInfo,
        OpenApi,
        SvgIcon,
        RolePermission
    },
    data() {
        return {
            activeIndex: 1,
            formData: {'access_token': ''}
        }
    },
    computed: {
        currentComponent() {
            const componentMap = {
                1: 'BasicSettings',
                2: 'BackgroundScraping',
                3: 'BackgroundTasks',
                4: 'XiaoaiSpeaker',
                5: 'WebdavMusic',
                6: 'SystemInfo',
                7: 'OpenApi',
                8: 'RolePermission'
            }
            return componentMap[this.activeIndex] || 'BasicSettings'
        }
    },
    created() {
        this.fetchSysDict()
    },
    methods: {
        handleActive(index) {
            this.activeIndex = index
        },
        fetchSysDict() {
            this.$api.Task.getSysDict().then((res) => {
                if (res.result) {
                    this.formData = res.data
                }
            })
        },
        HandleUpdateSys(key) {
            let value = this.formData[key]
            if (value.constructor === Boolean) {
                value = value ? '1' : '0'
            }
            if (key === 'silence_modify_list' || key === 'silence_source_list') {
                value = value.join(',')
            } else if (key === 'dir_list') {
                value = JSON.stringify(value)
            } else if (key === 'device_list' || key === 'silence_music_info') {
                value = JSON.stringify(value)
            } else if (key === 'backend_task') {
                value = JSON.stringify(value)
            } else if (key === 'mi_play_in_pl') {
                window.localStorage.setItem('mi_play_in_pl', value)
            }
            this.$api.Task.UpdateSys({ 'key': key, value: value }).then((res) => {
                this.$myMsg.notify({
                    title: '修改成功！',
                    type: 'success',
                    time: 1000,
                })
            })
        },
        redirctEditDetail(path) {
            if (this.$route.name !== 'home') {
                this.$router.push({ name: 'home' })
            }
            this.$store.commit('setFullPath', path)
        }
    }
}
</script>
